import { authLayout } from "../helpers/withAuth";

export const issuesRoutes = {
  path: "issues",
  ...authLayout("Issues", [
    {
      path: "/issues/",
      lazy: () =>
        import("../../modules/bug-reporting").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/issues/:id",
      lazy: () =>
        import("../../modules/bug-reporting/view").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};
